var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-inline-block mb-3 mb-sm-0 brand-logo",attrs:{"href":_vm.getFullUrl(_vm.url)}},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ed48b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/HeaderHomeComponent.vue
// module id = xR69
// module chunks = 0